// extracted by mini-css-extract-plugin
export default {"title":"d0765936305ce07556ba","body":"d0b4f04accd93b2b18ea"};